module.exports = __webpack_public_path__ + "media/BIENVENIDA.0678c208.mp3";